import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppContextProvider } from "components/Context/AppContext";
import { AuthProvider } from "components/Context/AuthContext";
import WebsitehomePage from "pages/Websitehome";
import About from "pages/About";
import Pricing from "pages/Pricing";
import NotFound from "pages/NotFound";
import Portfolios from "pages/Portfolios";
import Login from "pages/Login";
import CreateAccount from "pages/CreateAccount";
import CreateAccount2 from "pages/CreateAccount/CreateAccountPage2";
import RiskModel from "pages/RiskModel";
import Dashboard from "pages/Dashboard";
import Solutions from "pages/Solutions";
import ResetPassword from "pages/ResetPassword";
import LoginRequired from "components/Context/LoginRequired";
import PortfolioUpload from "pages/PortfolioUpload";
import ForgetPassword from "pages/ForgetPassword";
import UserApproval from "pages/UserApproval";
import ResetPasswordAfterLogin from "pages/ResetPasswordAfterLogin";
import UpdateEntitlement from "pages/UpdateEntitlement";
import Admin from "pages/Admin";
import BetaVersion from "pages/BetaVersion";
import ScheduleDemo from "pages/ScheduleDemo";
import PBIReport from "pages/PBIReport";
import PageUploadSecurity from "pages/UploadSecurity";



function App() {


  return (
    <AuthProvider>
      <AppContextProvider>
        <Router>    
          <div className="content">
              <Routes>
                <Route exact path="/"         element={<WebsitehomePage />} />
                <Route path="/home"           element={<WebsitehomePage />} />
                <Route path="/login"          element={<Login           />} />
                <Route path="/createAccount"  element={<CreateAccount   />} />
                <Route path="/createAccount2" element={<CreateAccount2  />} />
                <Route path="/about"          element={<About           />} />
                <Route path="/RiskModel"      element={<RiskModel       />} />
                <Route path="/BetaVersion"    element={<BetaVersion     />} />
                <Route path="/PBIReport"      element={<PBIReport       />} />

                <Route path="/dashboard"        element={<LoginRequired> <Dashboard /> </LoginRequired>} />
                <Route path="/portfolioUpload"  element={<LoginRequired> <PortfolioUpload /> </LoginRequired> } />
                <Route path="/portfolios"       element={ <Portfolios />  } />
                <Route path="/solutions"        element={<Solutions />     } />
                <Route path="/scheduleDemo"     element={<ScheduleDemo />  } />

                <Route path="/resetPassword/:token"     element={<ResetPassword             />} />
                <Route path="/resetPasswordafterlogin"  element={<ResetPasswordAfterLogin   />} />
                <Route path="/forgetPassword"        element={<ForgetPassword    /> } />
                
                <Route path="/userApproval"          element={<LoginRequired> <UserApproval      /> </LoginRequired> } />
                <Route path="/updateEntitlement"     element={<LoginRequired> <UpdateEntitlement /> </LoginRequired> } />
                <Route path="/admin"                 element={<LoginRequired> <Admin             /> </LoginRequired> } />
                <Route path="/pageUploadSecurity"    element={<LoginRequired> <PageUploadSecurity /> </LoginRequired> } />

                
                <Route path="*"               element={<NotFound        />} />


              </Routes>
            </div>

        </Router>
      </AppContextProvider>
    </AuthProvider>
  );
}

export default App;
